"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _modal = _interopRequireDefault(require("ant-design-vue/es/modal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = function _default(Vue) {
  function dialog(component, componentProps, modalProps) {
    var _vm = this;
    modalProps = modalProps || {};
    if (!_vm || !_vm._isVue) {
      return;
    }
    var dialogDiv = document.querySelector('body>div[type=dialog]');
    if (!dialogDiv) {
      dialogDiv = document.createElement('div');
      dialogDiv.setAttribute('type', 'dialog');
      document.body.appendChild(dialogDiv);
    }
    var handle = function handle(checkFunction, afterHandel) {
      if (checkFunction instanceof Function) {
        var res = checkFunction();
        if (res instanceof Promise) {
          res.then(function (c) {
            c && afterHandel();
          });
        } else {
          res && afterHandel();
        }
      } else {
        // checkFunction && afterHandel()
        checkFunction || afterHandel();
      }
    };
    var dialogInstance = new Vue({
      data: function data() {
        return {
          visible: true
        };
      },
      router: _vm.$router,
      store: _vm.$store,
      mounted: function mounted() {
        var _this = this;
        this.$on('close', function (v) {
          _this.handleClose();
        });
      },
      methods: {
        handleClose: function handleClose() {
          var _this2 = this;
          handle(this.$refs._component.onCancel, function () {
            _this2.visible = false;
            _this2.$refs._component.$emit('close');
            _this2.$refs._component.$emit('cancel');
            dialogInstance.$destroy();
          });
        },
        handleOk: function handleOk() {
          var _this3 = this;
          handle(this.$refs._component.onOK || this.$refs._component.onOk, function () {
            _this3.visible = false;
            _this3.$refs._component.$emit('close');
            _this3.$refs._component.$emit('ok');
            dialogInstance.$destroy();
          });
        }
      },
      render: function render(h) {
        var that = this;
        var modalModel = modalProps && modalProps.model;
        if (modalModel) {
          delete modalProps.model;
        }
        var ModalProps = Object.assign({}, modalModel && {
          model: modalModel
        } || {}, {
          attrs: Object.assign({}, _objectSpread({}, modalProps.attrs || modalProps), {
            visible: this.visible
          }),
          on: Object.assign({}, _objectSpread({}, modalProps.on || modalProps), {
            ok: function ok() {
              that.handleOk();
            },
            cancel: function cancel() {
              that.handleClose();
            }
          })
        });
        var componentModel = componentProps && componentProps.model;
        if (componentModel) {
          delete componentProps.model;
        }
        var ComponentProps = Object.assign({}, componentModel && {
          model: componentModel
        } || {}, {
          ref: '_component',
          attrs: Object.assign({}, _objectSpread({}, componentProps && componentProps.attrs || componentProps)),
          on: Object.assign({}, _objectSpread({}, componentProps && componentProps.on || componentProps))
        });
        return h(_modal.default, ModalProps, [h(component, ComponentProps)]);
      }
    }).$mount(dialogDiv);
  }
  Object.defineProperty(Vue.prototype, '$dialog', {
    get: function get() {
      return function () {
        dialog.apply(this, arguments);
      };
    }
  });
};